// src/design/forms/datepicker/utilities/pipeline.ts
function e(...e) {
	let t = [], n, r = (e) => (t.push({
		middleware: e,
		guard: n
	}), n = void 0, {
		push: r,
		guard: i,
		execute: a
	}), i = (e) => (n = e, {
		push: r,
		guard: i,
		execute: a
	}), a = (e) => {
		let n = -1, r = (e, i) => {
			if (e === n) throw Error("next() called multiple times");
			n = e;
			let a = t[e];
			if (a) {
				let { middleware: t, guard: n } = a;
				if (!n || n(i)) t(i, (t) => r(e + 1, t || i));
				else return r(e + 1, i);
			}
			return i;
		};
		return r(0, e);
	};
	return e.forEach((e) => r(e)), {
		push: r,
		guard: i,
		execute: a
	};
}
export { e as Pipeline };

//# sourceMappingURL=pipeline.js.map